import axios from "axios";
import store from "../redux/store";
import { logout } from "units/auth/store/authSlice";
import config from "../config";

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 60000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const isPublicRequest =
      config.url?.includes("/login") || config.url?.includes("/signup");

    // زبان فعلی کاربر
    const locale =
      localStorage.getItem("rayabot-client-lang") || "fa";

    // ارسال زبان به بک‌اند
    config.headers["X-Locale"] = locale;

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch(logout());
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;